import { render, staticRenderFns } from "./SpotPage.vue?vue&type=template&id=171bcf3e&scoped=true"
import script from "./SpotPage.vue?vue&type=script&lang=js"
export * from "./SpotPage.vue?vue&type=script&lang=js"
import style0 from "./SpotPage.vue?vue&type=style&index=0&id=171bcf3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171bcf3e",
  null
  
)

export default component.exports